<template>
	<div>
		<router-view />
		<Toast ref="toastRef" />
		<LoadingPage />
	</div>
</template>
<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue'
import { Toast } from '@shared-components'

export default defineComponent({
	name: 'App',
	components: { Toast },
	setup() {
		// 使用 ref 來引用 Toast 實例
		const toastRef = ref<InstanceType<typeof Toast> | null>(null)

		/**
		 * 掛載時執行
		 * @return {void}
		 */
		onMounted(() => {
			// 註冊全域 toast 方法
			window.$toast = toastRef.value?.showToast
			window.$hideToast = toastRef.value?.hideToast
		})

		return {
			toastRef,
		}
	},
})
</script>
<style lang="scss">
@use '@shared-assets/scss/base.scss' as *;

body {
	background-color: #{$background-color} !important;
}
</style>
